export function getPublicHolidayInfo(publicHolidaysByDate, dateStr) {
  if (!dateStr || !publicHolidaysByDate) return null;
  return publicHolidaysByDate[dateStr] || null;
}

export function isPublicHolidayDate(publicHolidaysByDate, dateStr) {
  return Boolean(getPublicHolidayInfo(publicHolidaysByDate, dateStr));
}

export function getPublicHolidayCalendarTitle(holidayInfo) {
  if (!holidayInfo) return "Public Holiday";
  const name = String(holidayInfo.holidayName || "").trim();
  return name || "Public Holiday";
}

export function buildHolidayDateSet(publicHolidaysByDate = {}) {
  return new Set(Object.keys(publicHolidaysByDate || {}));
}
